const STORAGE_KEY = "techxm_newsletter_subscribers";

function normalizeEmail(email) {
  return String(email || "").trim().toLowerCase();
}

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function subscribeToNewsletter(email) {
  const normalized = normalizeEmail(email);

  if (!normalized) {
    return { ok: false, message: "Please enter your email address." };
  }

  if (!isValidEmail(normalized)) {
    return { ok: false, message: "Please enter a valid email address." };
  }

  const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  const alreadySubscribed = existing.some((item) => item.email === normalized);

  if (alreadySubscribed) {
    return { ok: true, message: "You are already subscribed to the newsletter." };
  }

  const updated = [
    ...existing,
    {
      email: normalized,
      subscribedAt: new Date().toISOString(),
    },
  ];

  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  return { ok: true, message: "Thanks for subscribing to the TECHXM newsletter." };
}

